var array = Array.prototype;

export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-contour/src/array.js
// module id = null
// module chunks = 